import './Login.scss';
import * as React from 'react';
import { IActions } from './store/actions/creators';
import Button from '../../ui-components/Button/Button';
import { useAuth0 } from './react-auth0-spa';

export const Login = (props: IActions) => {
    const { loginWithPopup } = useAuth0();

    const login = async (e?) => {
        e.preventDefault();
        const profile = await loginWithPopup();
        // console.info("--------------> LOGIN profile", profile)
        props.loginSuccess(profile);
        props.navigateTo('/');
    }

    return (
        <div className="login-page">
            <img alt='area ferrero' src="/favicon-32x32.png" />
            <p>Sei un <b>Amministratore</b>? <br />Effettua il login per accedere all'area amministrativa.</p>
            <p>Sei un <b>Cliente</b>? <br />Effettua il login per eliminare il tuo account dal sistema.</p>
            <Button onClick={login}>Login</Button>
        </div>
    );
}